export const questions = [
  {
    id: 10,
    quest: '¿Tiene Registro Único Tributario (RUT)?',
    value: '',
    disabled: false,
    error: false,
  },
  {
    id: 11,
    quest: '¿Tiene Registro Mercantil?',
    value: '',
    disabled: false,
    error: false,
  },
  {
    id: 12,
    quest: '¿Renueva el Registro Mercantil cada año?',
    value: '',
    disabled: false,
    error: false,
  },
  {
    id: 13,
    quest: '¿Paga su salud, pensiones y riesgos laborales de los trabajadores?',
    value: '',
    disabled: false,
    error: false,
  },
  {
    id: 14,
    quest: '¿Paga su salud, pensiones y riesgos laborales?',
    value: '',
    disabled: false,
    error: false,
  },
  {
    id: 15,
    quest:
      '¿Conoce los requerimientos o permisos para desarrollar su actividad y cumple con estos?',
    value: '',
    disabled: false,
    error: false,
  },
  {
    id: 16,
    quest: '¿Conoce los deberes y obligaciones tributarias de su actividad?',
    value: '',
    disabled: false,
    error: false,
  },
];
